import ShinhanImg from "../assets/images/bank-card-images/shinhan.png";
import HyunDaiImg from "../assets/images/bank-card-images/hyun-dai.png";
import SamSungImg from "../assets/images/bank-card-images/samsung.png";
import KbImg from "../assets/images/bank-card-images/kb-bank.png";
import LotteCardImg from "../assets/images/bank-card-images/lotte-card.png";
import HanaBankImg from "../assets/images/bank-card-images/hana-bank.png";
import WooriImg from "../assets/images/bank-card-images/woori.png";
import NhImg from "../assets/images/bank-card-images/nh.png";
import CitiImg from "../assets/images/bank-card-images/citi.png";
import BcCardImg from "../assets/images/bank-card-images/bc-card.png";
import SuhyeobImg from "../assets/images/bank-card-images/suhyeob.png";
import JeonbukImg from "../assets/images/bank-card-images/jeonbuk.png";
import KBankImg from "../assets/images/bank-card-images/k-bank.png";
import PostOfficeImg from "../assets/images/bank-card-images/post-office.png";
import KdbImg from "../assets/images/bank-card-images/kdb.png";
import SaemaulGeumgoImg from "../assets/images/bank-card-images/saemaul-geumgo.png";
import SinhyeobImg from "../assets/images/bank-card-images/sinhyeob.png";

export const CARD_DATA = [
  {
    code: "001",
    fcode: "366",
    name: "신한카드",
    bankImg: ShinhanImg,
    homePageAddr: "https://www.shinhancard.com",
  },
  {
    code: "002",
    fcode: "367",
    name: "현대카드",
    bankImg: HyunDaiImg,
    homePageAddr: "https://www.hyundaicard.com",
  },
  {
    code: '003',
    fcode: "365",
    name: "삼성카드",
    bankImg: SamSungImg,
    homePageAddr: "https://www.samsungcard.com",
  },
  {
    code: "004",
    fcode: "381",
    name: "KB국민카드",
    bankImg: KbImg,
    homePageAddr: "https://www.kbcard.com",
  },
  {
    code: '005',
    fcode: "368",
    name: "롯데카드",
    bankImg: LotteCardImg,
    homePageAddr: "https://www.lottecard.co.kr",
  },
  {
    code: '006',
    fcode: "374",
    name: "하나카드",
    bankImg: HanaBankImg,
    homePageAddr: "https://www.hanacard.co.kr",
  },
  {
    code: '007',
    fcode: "041",
    name: "우리카드",
    bankImg: WooriImg,
    homePageAddr: "https://www.wooricard.com",
  },
  {
    code: "008",
    fcode: "371",
    name: "농협카드",
    bankImg: NhImg,
    homePageAddr: "https://card.nonghyup.com",
  },
  {
    code: "009",
    fcode: "370",
    name: "씨티카드",
    bankImg: CitiImg,
    homePageAddr: "https://www.citibank.co.kr",
  },
  {
    code: "010",
    fcode: "361",
    name: "BC카드",
    bankImg: BcCardImg,
    homePageAddr: "https://www.bccard.com",
  },
  {
    code: "011",
    fcode: "369",
    name: "수협카드",
    bankImg: SuhyeobImg,
    homePageAddr: "https://www.suhyup-bank.com",
  },
  {
    code: "012",
    fcode: "364",
    name: "광주카드",
    bankImg: JeonbukImg,
    homePageAddr: "https://www.kjbank.com",
  },
  {
    code: "013",
    fcode: "372",
    name: "전북카드",
    bankImg: JeonbukImg,
    homePageAddr: "https://www.jbbank.co.kr",
  },
  {
    code: "015",
    fcode: "089",
    name: "케이뱅크카드",
    bankImg: KBankImg,
    homePageAddr: "https://www.kbanknow.com",
  },
  {
    code: "016",
    fcode: "071",
    name: "우체국카드",
    bankImg: PostOfficeImg,
    homePageAddr: "https://www.epostbank.go.kr",
  },
  {
    code: "017",
    fcode: "002",
    name: "산업카드",
    bankImg: KdbImg,
    homePageAddr: "https://www.kdb.co.kr",
  },
  {
    code: "018",
    fcode: "045",
    name: "새마을카드",
    bankImg: SaemaulGeumgoImg,
    homePageAddr: "https://www.kfcc.co.kr",
  },
  {
    code: "014",
    fcode: "035",
    name: "제주카드",
    bankImg: ShinhanImg,
    homePageAddr: "https://www.e-jejubank.com",
  },
  {
    code: "020",
    fcode: "048",
    name: "신협카드",
    bankImg: SinhyeobImg,
    homePageAddr: "https://openbank.cu.co.kr",
  },
];

export const CARD_TYPE = [
  { label: "법인", value: "ccd" },
  { label: "개인", value: "card" },
];
